<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { LinkIcon } from "../icons";
import { clientIdentity } from "../clientIdentity";
const props = defineProps<{ brand?: string | null; name?: string }>(),
  failed = ref(false);
const url = computed(() =>
  clientIdentity(props.brand, props.name)
    ? `/brand/ai-clients/${clientIdentity(props.brand, props.name)}.png`
    : null,
);
watch(url, () => {
  failed.value = false;
});
</script>
<template>
  <img
    v-if="url && !failed"
    :src="url"
    width="24"
    height="24"
    alt=""
    class="client-brand"
    @error="failed = true"
  /><LinkIcon v-else :size="24" />
</template>
<style scoped lang="scss" src="../styles/components/ClientBrand.scss"></style>
